import CompanyUser from "../company-user";
import AppLoader_Report from "../../../../item-view/report/app-loader";
import ReportVacationReport from "../../report/reports/hr/vacation-report/vaction-report";

export default class CompanyUserActions {

    private companyUser: CompanyUser

    constructor(companyUser: CompanyUser) {
        this.companyUser = companyUser
    }

    delete = () => {gd.goTo('o/users/delete/{0}'.f(this.companyUser.user.id))}

    showSummary =   () => {gd.goTo('u/{0}/summary'.f(this.companyUser.id))}
    showTasks =     () => {gd.goTo('u/{0}/tasks'.f(this.companyUser.id))}
    showActivity =  () => {gd.goTo('u/{0}/activity'.f(this.companyUser.id))}
    // showCalendar =  () => {gd.goTo('u/{0}/calendar'.f(this.companyUser.id))}
    showCalendar =  () => {
        const appParams = {
            report: new ReportVacationReport({
                id: "vacation-report",
                name: "Vacation report",
                autoGenerate: false,
                settings: {
                    userId: this.companyUser.userId,
                }
            })
        }

        gd.appManager.loadAndRunItemView(AppLoader_Report, appParams)

    }
}
